/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBoxSeam = createReactComponent("box-seam", "IconBoxSeam", [
  ["path", { d: "M12 3l8 4.5v9l-8 4.5l-8 -4.5v-9l8 -4.5", key: "svg-0" }],
  ["path", { d: "M12 12l8 -4.5", key: "svg-1" }],
  ["path", { d: "M8.2 9.8l7.6 -4.6", key: "svg-2" }],
  ["path", { d: "M12 12v9", key: "svg-3" }],
  ["path", { d: "M12 12l-8 -4.5", key: "svg-4" }]
]);

export { IconBoxSeam as default };
//# sourceMappingURL=IconBoxSeam.js.map
